import { APP_IS_OFFLINE, APP_IS_ONLINE } from './constants'

export const setAppIsOffline = () => ({
  type: APP_IS_OFFLINE,
})

export const setAppIsOnline = () => ({
  type: APP_IS_ONLINE,
})
